import { useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import API from "../../api";
import IntegerationSteps from "../../components/integerationSteps";
import Loader from "../../components/loader";
import PersonalDetails from "../../components/personalDetails";

export default function Settings() {
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const [settingsData, setSettingsData] = useState({});
  const getSettingsData = async () => {
    setLoading(true);
    await API("/partner/partner-info?settings=true", "GET")
      .then((data) => {
        if (data) {
          console.log(data);
          if (data?.result) {
            setSettingsData(data?.result);
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        toast({
          title: "Error in fetching data!",
          description: err?.error ?? "Internal Server Error!",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
        console.log("error", err);
      });
  };

  useEffect(() => {
    getSettingsData();
  }, []);

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <IntegerationSteps data={settingsData} setData={setSettingsData} />
      <PersonalDetails data={settingsData} setData={setSettingsData} />
    </>
  );
}
